import { http } from "./client";
import type { HRDashboard } from "@/types/domain";

/**
 * HR Employee's landing page - a single backend-computed aggregate (like
 * financeApi.dashboard's GET /finance/dashboard), scoped server-side to the
 * caller's branch/department ABAC assignments (see BranchAssignment/
 * DepartmentAssignment in types/domain.ts). See lib/api/finance.ts for the
 * sibling this mirrors.
 */
export const hrDashboardApi = {
  get: () => http.get<HRDashboard>("/hr/dashboard"),
};
